/**
 * @velyn-custom BEGIN — vely-main-cart.js
 * Adds missing MainCart helpers used when the last cart item is removed
 * (Core ProductForm.updateMainCart calls cart.updateCartIcon).
 */
(function () {
  const defineWhenReady = () => {
    const MainCart = customElements.get("main-cart");
    if (!MainCart) {
      document.addEventListener("DOMContentLoaded", defineWhenReady, { once: true });
      return;
    }

    const proto = MainCart.prototype;
    if (typeof proto.updateCartIcon !== "function") {
      proto.updateCartIcon = function updateCartIcon(sectionElement) {
        if (!sectionElement) return;
        const countSource = sectionElement.querySelector(".cart-count");
        if (!countSource) return;

        ["#cart-icon-bubble", "#cart-icon-bubble-mobile"].forEach((selector) => {
          const nav = document.querySelector(selector);
          const countTarget = nav && nav.querySelector(".cart-count");
          if (countTarget) {
            countTarget.innerHTML = countSource.innerHTML;
          }
        });
      };
    }

    if (typeof proto.getSectionInnerHTML !== "function") {
      proto.getSectionInnerHTML = function getSectionInnerHTML(html, selector = ".shopify-section") {
        const node = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
        return node ? node.innerHTML : "";
      };
    }
  };

  defineWhenReady();
})();
/* @velyn-custom END — vely-main-cart.js */
